"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaginatedContentReports = void 0;
const tslib_1 = require("tslib");
const omit_1 = tslib_1.__importDefault(require("lodash/omit"));
const __enums_1 = require("../../../../__types/__enums");
const createReport_1 = require("../../../__common/createReport");
const elasticsearchQuery_1 = require("../../../__common/elasticsearchQuery");
const getElasticsearchSortForSortParams_1 = require("../../../__common/elasticsearchQuery/getElasticsearchSortForSortParams");
const reportHelpers_1 = require("../../../__common/reportHelpers");
const addFilters_1 = require("../../common/addFilters");
const getAggregation_1 = require("../../common/getAggregation");
const contentsByQuery_1 = require("../../contentsByQuery");
const getContentsByIds_1 = require("../../getContentsByIds");
const getChannelMetrics_1 = require("../common/getChannelMetrics");
const getContentMetrics_1 = require("../common/getContentMetrics");
const toIncludeContentVersionLogs_1 = require("../common/toIncludeContentVersionLogs");
const toIncludeRootContent_1 = require("../common/toIncludeRootContent");
function getPaginatedContentReports(rp, input, searchMatchConfig) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { ReportParams: reportParmas, ReportProjection = {} } = input;
        const { contentProjection } = ReportProjection;
        const { filters, from = 0, size = 100 } = reportParmas;
        // adding default filters of isPublished and isDraft for content search
        addFilters_1.addDefaultFiltersForContentSearch(filters.contentFilters);
        const customProjection = contentProjection && contentProjection.custom;
        const sortParams = input.SortParams;
        const query = elasticsearchQuery_1.getElasticsearchQueryFromFiltersAndSearch(filters.contentFilters, searchMatchConfig);
        const aggs = getAggregation_1.getAggregationForContentReport(customProjection);
        if (Object.keys(query.bool).length > 0) {
            const { contents, total, contentTypeAggregation } = yield contentsByQuery_1.getContentsByQuery({
                requestType: __enums_1.ReportRequestTypeEnum.PAGINATED,
                _source: omit_1.default(contentProjection, ['custom']),
                from,
                size,
                body: { query, aggs },
                sort: !searchMatchConfig ? getElasticsearchSortForSortParams_1.getElasticsearchSortForSortParams(sortParams || []) : undefined
            });
            const promises = [];
            const withRootContent = toIncludeRootContent_1.toInlcudeRootContent(contentProjection);
            const withContentVersionLog = toIncludeContentVersionLogs_1.toIncludeContentVersionLogs(contentProjection);
            if (withRootContent) {
                promises.push(getContentsByIds_1.attachRootContent(rp, contents));
            }
            if (withContentVersionLog) {
                promises.push(getContentsByIds_1.attachContentVersionLogToRootContent(rp, contents));
            }
            yield Promise.all(promises);
            // Fetching contentMetrics corresponding to matching results
            let contentMetrics = [];
            let channelMetrics = [];
            if (customProjection && customProjection.indexOf('contentMetrics') >= 0) {
                contentMetrics = yield getContentMetrics_1.getContentMetrics(contents, filters.stateFilters);
            }
            // Fetching channelMetrics corresponding to matching results
            if (customProjection && customProjection.indexOf('channelMetrics') >= 0) {
                channelMetrics = yield getChannelMetrics_1.getChannelMetrics(contents);
            }
            // Fetching and setting related users like reviewer, assigner
            if (ReportProjection.relatedUserProjection) {
                yield reportHelpers_1.setRelatedUsers(rp, ReportProjection.relatedUserProjection, contents);
            }
            if (ReportProjection.relatedGroupProjection) {
                yield reportHelpers_1.setRelatedGroups(rp, ReportProjection.relatedGroupProjection, contents);
            }
            contentMetrics = contentMetrics.concat(channelMetrics);
            return createReport_1.createContentReport({ contentTypeAggregation, contentMetrics, contents, total });
        }
        return createReport_1.createContentReport({ contentTypeAggregation: [], contentMetrics: [], contents: [], total: 0 });
    });
}
exports.getPaginatedContentReports = getPaginatedContentReports;
//# sourceMappingURL=index.js.map